module.exports = "/static/assets/f6f8dd016f007f80d2e79c5bac02aa21.png";